/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Currency_Eur3Inputs */

const he_currency_eur3 = /** @type {(inputs: Currency_Eur3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EUR - Euro`)
};

const en_currency_eur3 = /** @type {(inputs: Currency_Eur3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EUR - Euro`)
};

/**
* | output |
* | --- |
* | "EUR - Euro" |
*
* @param {Currency_Eur3Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const currency_eur3 = /** @type {((inputs?: Currency_Eur3Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Currency_Eur3Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_currency_eur3(inputs)
	return en_currency_eur3(inputs)
});
export { currency_eur3 as "currency_EUR" }